<template>
  <div class="survey">
    <div class="row eq-height">
      <div class="col-lg-7 survey-left">
        <div class="row mt-20 side-pad survey-header">
          <div class="col-6">
            <router-link to="/">
                <img class="survey__image"
                    src="@/assets/img/bettermynd-logo@2x.png"
                    alt="BetterMynd"
                >
            </router-link>
          </div>
        </div>
        <div class="survey-content text-center">
            <div class="vertical-align-md">
                <card page="survey_layout" class="survey__card">
                    <main>
                        <slot />
                    </main>
                </card>
            </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-5 survey-right">
        <div class="vertical-align-md">
          <img
            class="survey__image"
            src="@/assets/img/login-img@2x.png"
            alt="BetterMynd"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
export default {
    components: {
        Card
    }
}
</script>

<style lang="scss" scoped>
.survey {
  overflow: hidden;

  &__image {
    height: 48px;
    margin-bottom: 0;
  }

  &__card {
    display: block;
    max-width: 575px;
    margin: 0 auto;
    text-align: left;
  }

  .side-pad {
    @media (min-width: $md-min) {
      padding-right: 15px;
      padding-left: 15px;
    }
  }

  .survey-left {
    background: $blue;

    @media (min-width: $lg-min) {
      height: 100vh;
      min-height: 600px;
    }

    .survey-header {
        padding-left: 25px;
    }
  }

  .survey-right {
    text-align: center;
    overflow: hidden;

    @media (min-width: $lg-min) {
      text-align: left;
      height: 100vh;
      min-height: 600px;
      background: rgb(42, 122, 161);
      background: linear-gradient(180deg, rgba(42, 122, 161, 1) 0%, rgba(40, 102, 159, 1) 100%);
    }

    img {
      width: 120%;
      height: auto;
      position: relative;
      z-index: 2;
      left: -7%;

      @media (max-width: $md-max) {
        left: auto;
        right: auto;
        width: 75%;
        margin: 0 auto;
        background: rgb(42, 122, 161);
        background: linear-gradient(180deg, rgba(42, 122, 161, 1) 0%, rgba(40, 102, 159, 1) 100%);
      }
    }
  }

  .survey-content {
    position: relative;
    margin-top: 60px;
    margin-bottom: 60px;

    @media (min-width: $md-min) {
      height: calc(100vh - 180px);
      margin-top: 0;
      margin-bottom: 0;
      min-height: 700px;
    }

    ::v-deep .card {
      padding: 60px;
      margin-bottom: 30px;

      @media (min-width: $md-min) {
        margin-top: 30px;
      }

      h1 {
        font-size: 32px;
        line-height: 1;
        margin-bottom: 20px;
      }
    }
  }
}
</style>